// ==========================================================================
// PRIMITIVES UI PARTAGÉES DES CAS PRATIQUES
// Extrait de PariteFusion.jsx (lot 0 du module Mali) : champ numérique à
// saisie souple, titres de section, cartes métriques, lignes d'alerte et
// styles de base — partagés entre les services (Parité, Mali…).
// ==========================================================================
import React, { useState } from "react";
import { P } from "./palette";
import { parseMoney } from "./format";

// ── Styles de base ────────────────────────────────────────────────────────
export const inS = { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 7, padding: "7px 9px", color: P.text, fontSize: 12.5, fontFamily: "monospace", outline: "none", boxSizing: "border-box", width: "100%" };
export const lbS = { fontSize: 11, fontWeight: 600, color: P.textMuted, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4, display: "block" };
export const thS = { padding: "7px 8px", textAlign: "right", color: P.textMuted, fontWeight: 600, fontSize: 10.5, textTransform: "uppercase", letterSpacing: "0.04em", borderBottom: "1px solid rgba(255,255,255,0.08)", whiteSpace: "nowrap" };
export const tdS = { padding: "6px 8px", textAlign: "right", fontSize: 12, fontFamily: "monospace", borderBottom: "1px solid rgba(255,255,255,0.04)" };

// Champ numérique : édite du texte libre, parse au blur, affiche formaté.
export const NumIn = ({ v, oc, fmt, ph, disabled, style }) => {
  const [ed, setEd] = useState(false);
  const [raw, setRaw] = useState("");
  return (
    <input
      type="text" placeholder={ph} disabled={disabled}
      value={ed ? raw : (v == null ? "" : fmt(v))}
      onFocus={(e) => { setEd(true); setRaw(v == null ? "" : String(v).replace(".", ",")); e.target.style.borderColor = "rgba(255,255,255,0.5)"; }}
      onChange={(e) => setRaw(e.target.value)}
      onBlur={(e) => { setEd(false); oc(parseMoney(raw)); e.target.style.borderColor = "rgba(255,255,255,0.08)"; }}
      style={{ ...inS, textAlign: "right", opacity: disabled ? 0.35 : 1, ...style }}
    />
  );
};

export const SecT = ({ n, t }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "28px 0 12px" }}>
    <span style={{ fontSize: 11, fontWeight: 700, color: P.accent, fontFamily: "monospace" }}>{n}</span>
    <h3 style={{ fontSize: 13, fontWeight: 700, color: P.textSec, margin: 0, textTransform: "uppercase", letterSpacing: "0.07em" }}>{t}</h3>
    <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.05)" }} />
  </div>
);

export const Metric = ({ lb, v, a = P.accent }) => (
  <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 11, padding: "12px 14px", position: "relative", overflow: "hidden" }}>
    <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: a }} />
    <div style={{ fontSize: 10.5, color: P.textMuted, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{lb}</div>
    <div style={{ fontSize: 19, fontWeight: 700, color: P.text, fontFamily: "monospace" }}>{v}</div>
  </div>
);

export const WarnLine = ({ children, tone = "warn" }) => {
  const c = tone === "err" ? "#ef4444" : tone === "ok" ? "#22c55e" : "#fbbf24";
  const bg = tone === "err" ? "rgba(239,68,68,0.08)" : tone === "ok" ? "rgba(34,197,94,0.07)" : "rgba(251,191,36,0.06)";
  return (
    <div style={{ background: bg, border: `1px solid ${c}30`, borderRadius: 8, padding: "8px 12px", fontSize: 12, color: c, lineHeight: 1.5, marginTop: 8 }}>
      {children}
    </div>
  );
};
